import type { LicensingRole } from "@/auth/token-session";

export type UICapability =
  | "admin-shell"
  | "request-lookup"
  | "request-detail"
  | "linked-station-read"
  | "recovery-decommission";

export const uiCapabilityMatrix = {
  admin: {
    roles: ["licensing-admin"],
    requestClientAccess: "not-required",
    capabilities: ["admin-shell", "request-lookup", "request-detail", "linked-station-read", "recovery-decommission"]
  },
  accessibleOperator: {
    roles: ["licensing-operator"],
    requestClientAccess: "allowed",
    capabilities: ["request-lookup", "request-detail", "linked-station-read", "recovery-decommission"]
  },
  inaccessibleOperator: {
    roles: ["licensing-operator"],
    requestClientAccess: "denied-as-not-found",
    capabilities: ["request-lookup"]
  },
  noLicensingRole: {
    roles: [],
    requestClientAccess: "not-applicable",
    capabilities: []
  }
} as const;

export function hasRole(roles: ReadonlySet<LicensingRole>, role: LicensingRole) {
  return roles.has(role);
}

export function isAdmin(roles: ReadonlySet<LicensingRole>) {
  return hasRole(roles, "licensing-admin");
}

export function isOperator(roles: ReadonlySet<LicensingRole>) {
  return !isAdmin(roles) && hasRole(roles, "licensing-operator");
}

export function isReleaseApprover(roles: ReadonlySet<LicensingRole>) {
  return isAdmin(roles) || hasRole(roles, "licensing-release-approver");
}

export function operatorRouteAllowed(pathname: string, search: string) {
  if (pathname === "/clients" || pathname === "/product-activations" || /^\/clients\/[1-9]\d*$/.test(pathname)) {
    return true;
  }
  if (pathname === "/registration-requests" || pathname.startsWith("/registration-requests/")) {
    return true;
  }
  if (/^\/stations\/[0-9a-f-]{36}$/.test(pathname)) {
    return new URLSearchParams(search).has("recoveryRequestId");
  }
  return false;
}
